export const BASE_URL = '/app/dashboard';
export const BASE_TITLE = ' | iNOVAA';

export const CONFIG = {
  layout: 'vertical'
};
